import { isEmpty } from '@ember/utils';

export default function validateDate() {
  return (key, newValue /*, oldValue, changes, content*/) => {
    if (isEmpty(newValue) || typeof newValue.getMonth === 'function') {
      return true;
    }
    return 'Must be a date';
  };
}
